import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FeedbackTimeEditorComponent } from './feedback-time-editor.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { FormsModule } from '@angular/forms';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormatTimeModule,
		FormsModule
	],
	declarations: [
		FeedbackTimeEditorComponent
	],
	exports: [
		FeedbackTimeEditorComponent
	],
	providers: [
		TranslatePipe
	]
})
export class FeedbackTimeEditorModule {}
